// TODO use axios and add setup-api with axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URI

import axiosInstance from "@/setup/setup-api";
import qs from "query-string";

export default {
  // locally we have a proxy from /api to VUE_APP_API_PROXY_TARGET / which is http://localhost:3000
  endpointRootUrl: "/api/",
  /**
   * Get a document by id
   * @param endpointUrl
   * @param documentId
   * @param data - additional data to pass as query parameters
   * @param toThrow - if true, throw an error if document not found
   * @return {*}
   */
  async getDocument<T>(endpointUrl: string, documentId: string, data?: any, toThrow: boolean = false): Promise<T> {
    try {
      log.debug(`genericAPI getDocument endpointUrl=${endpointUrl} documentId=${documentId} data=${JSON.stringify(data)}`);
      let axiosConfig = {};
      if (!documentId) {
        documentId = "";
      }

      let qsResult = qs.stringify(data);
      qsResult = qsResult ? "?" + qsResult : "";

      const basePath = this.endpointRootUrl + endpointUrl;
      const uriEndpoint =
          basePath + (documentId ? `/${documentId}` : "") + qsResult;

      log.debug(`genericAPI getDocument uriEndpoint=${uriEndpoint}`);

      const response = await axiosInstance(uriEndpoint, axiosConfig);

      if (!response || !response.data) {
        log.debug('genericAPI getDocument response is empty:', response);
        if (toThrow) {
          throw new Error("Document not found");
        }
        return null;
      }

      return response.data as T;
    } catch (error) {
      log.error('Error getDocument:', error);
      throw error;
    }
  },

  /**
   * Get all documents
   * @param endpointUrl
   * @param data
   * @param toThrow - if true, throw an error if no documents found
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getDocuments<T>(endpointUrl: string, data?: any, toThrow: boolean = false): Promise<T[]> {
    try {
      log.debug(`genericAPI getDocuments endpointUrl=${endpointUrl} data=${JSON.stringify(data)}`);
      let axiosConfig = {};
      let qsResult = qs.stringify(data);
      qsResult = qsResult ? "?" + qsResult : "";

      const uriEndpoint = this.endpointRootUrl + endpointUrl + qsResult;
      log.debug(`genericAPI getDocuments uriEndpoint=${uriEndpoint}`);

      const response = await axiosInstance(uriEndpoint, axiosConfig);
      //|| !Array.isArray(response.data)
      if (!response || !response.data ) {
        log.debug('genericAPI getDocuments response is empty or invalid:', response);
        if (toThrow) {
          throw new Error("No documents found");
        }
        return [];
      }

      return response.data as T[];
    } catch (error) {
      log.error('Error getDocuments:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },

    /**
     * Get all documents with count
     * Same as above but return T (actually it is {results: T[], count: number})
     * @param endpointUrl
     * @param data
     * @returns {Promise<AxiosResponse<T>>}
     */
  async getDocumentsWithCount<T>(endpointUrl: string, data?: any): Promise<{results: T[], count: number}> {
    try {
      log.debug(`genericAPI getDocuments endpointUrl=${endpointUrl} data=${JSON.stringify(data)}`);
      let axiosConfig = {};
      let qsResult = qs.stringify(data);
      qsResult = qsResult ? "?" + qsResult : "";

      const uriEndpoint = this.endpointRootUrl + endpointUrl + qsResult;
      log.debug(`genericAPI getDocuments uriEndpoint=${uriEndpoint}`);

      const response = await axiosInstance(uriEndpoint, axiosConfig);
      return response.data as {results: T[], count: number};
    } catch (error) {
      log.error('Error getDocuments:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },

  /**
   * Create a new document
   * @param endpointUrl
   * @param data
   * @return {*}
   */
  async postDocument<T>(endpointUrl: string, data: object): Promise<T> {
    try {
      log.debug(`genericAPI postDocument endpointUrl=${endpointUrl} data=${JSON.stringify(data)}`);
      let axiosConfig = {};
      const response = await axiosInstance.post(this.endpointRootUrl + endpointUrl, data, axiosConfig);
      return response.data as T
    } catch (error) {
      log.error('Error postDocument:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },

    /**
     * Upload file
     * @param endpointUrl
     * @param formData
     * @return {*}
     */
  async postUploadFile<T>(endpointUrl: string, formData: object): Promise<T> {
    try {
      log.debug(`genericAPI postDocument endpointUrl=${endpointUrl} data=${JSON.stringify(formData)}`);
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const response = await axiosInstance.post(this.endpointRootUrl + endpointUrl, formData, axiosConfig);
      return response.data as T
    } catch (error) {
      log.error('Error postDocument:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },

  /**
   * Update a document
   * @param endpointUrl
   * @param data
   * @return {*}
   */
  async putDocument<T>(endpointUrl: string, data: object): Promise<T> {
    try {
      log.debug(`genericAPI putDocument endpointUrl=${endpointUrl} data=${JSON.stringify(data)}`);
      let axiosConfig = {};
      const response = await axiosInstance.put(this.endpointRootUrl + endpointUrl, data, axiosConfig);
      return response.data as T

    } catch (error) {
      log.error('Error putDocument:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },

  /**
   * Update a document partially
   * @param endpointUrl
   * @param data
   * @return {*}
   */
  async patchDocument<T>(endpointUrl: string, data: object): Promise<T> {
    try {
      log.debug(`genericAPI patchDocument endpointUrl=${endpointUrl} data=${JSON.stringify(data)}`);
      let axiosConfig = {};
      const response = await axiosInstance.patch(this.endpointRootUrl + endpointUrl, data, axiosConfig);
      return response.data as T
    } catch (error) {
      log.error('Error patchDocument:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },

  /**
   * Delete a document
   * @param endpointUrl
   * @param documentId
   * @return {*}
   */
  async deleteDocument<T>(endpointUrl: string, documentId: string): Promise<object> {
    try {
      log.debug(`genericAPI deleteDocument endpointUrl=${endpointUrl} documentId=${documentId}`);
      let axiosConfig = {};
      const response = await axiosInstance.delete(this.endpointRootUrl + endpointUrl + "/" + documentId, axiosConfig);
      // does not provide the old document
      return response.data;
    } catch (error) {
      log.error('Error deleteDocument:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  }
}
